/** US self-onboarding when the company, form country, or Genaisis session says so. */
export function isUsOnboardingMarket(input: {
  companyCountry?: unknown
  addressCountry?: unknown
  variant?: unknown
  sessionMarket?: unknown
  formCountryCode?: unknown
}): boolean {
  const countries = [input.companyCountry, input.addressCountry, input.formCountryCode].map(
    (value) =>
      String(value ?? '')
        .trim()
        .toLowerCase()
  )
  if (countries.includes('us')) return true
  if (
    String(input.variant ?? '')
      .trim()
      .toUpperCase() === 'USV1'
  )
    return true
  return (
    String(input.sessionMarket ?? '')
      .trim()
      .toLowerCase() === 'us'
  )
}
